<template>
  <a-modal
    width="548px"
    v-model="visible"
    wrap-class-name="consult-form-modal"
    :title="null"
    :footer="null"
    @cancel="cancel"
  >
    <div class="service-form">
      <p>我要咨询</p>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item ref="content" label="咨询主题" prop="content">
          <a-input
            v-model="form.content"
            placeholder="请输入咨询主题"
            @blur="
              () => {
                $refs.content.onFieldBlur();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item label="具体描述" prop="description">
          <a-input
            v-model="form.description"
            placeholder="请输入您想咨询的详细内容"
            type="textarea"
            :auto-size="{ minRows: 4, maxRows: 4 }"
          />
        </a-form-model-item>
        <a-form-model-item ref="companyId" label="咨询企业" prop="companyId">
          <a-select
            v-model="form.companyId"
            :filter-option="false"
            placeholder="选择咨询企业"
          >
            <a-empty
              slot="notFoundContent"
              :image-style="{ height: '50px' }"
              description="您还未加入企业"
            />
            <a-select-option v-for="item in companyList" :key="item.id">
              {{ item.companyName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          ref="contactPerson"
          label="联系人"
          prop="contactPerson"
        >
          <a-input
            v-model="form.contactPerson"
            placeholder="请输入真实姓名"
            :max-length="4"
            @blur="
              () => {
                $refs.contactPerson.onFieldBlur();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item
          ref="contactPhone"
          label="联系电话"
          prop="contactPhone"
        >
          <a-input
            v-model="form.contactPhone"
            placeholder="请输入联系电话"
            :max-length="11"
            @blur="
              () => {
                $refs.contactPhone.onFieldBlur();
              }
            "
          />
        </a-form-model-item>

        <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
          <a-button class="btn-red" @click="onSubmit" style="width: 100px"
            >提 交</a-button
          >
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
import VCountDown from "@/components/VCountDown";
import { serviceOrderLogCommit } from "@/api/service.js";
import { mapGetters } from "vuex";

export default {
  name: "service_form",
  props: ["show"],
  data() {
    const validatorPhone = (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号格式不正确!"));
      } else {
        callback();
      }
    };
    return {
      list: [],
      visible: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      isCode: true,
      simpleImage: "",
      form: {
        content: "",
        description: "",
        contactPerson: "",
        contactPhone: "",
        goodsType: "4",
      },
      rules: {
        content: [
          { required: true, message: "请输入咨询主题", trigger: "blur" },
        ],
        companyId: [{ required: true, message: "请选择企业", trigger: "blur" }],
        contactPerson: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
        ],
        contactPhone: [
          { required: true, validator: validatorPhone, trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    show: function (val) {
      this.visible = val;
      this.form.contactPhone = this.userInfo.phone;
      this.form.contactPerson = this.userInfo.realName;
    },
  },

  computed: {
    ...mapGetters(["companyList", "userInfo"]),
  },
  components: {
    VCountDown,
  },

  methods: {
    handle(info, type) {
      this.form.goodsId = info.id;
      this.form.goodsType = type;
      if (type === "1") {
        this.form.content = info.name;
        this.form.goodsName = info.name;
      }
      if (type === "2") {
        this.form.content = info.productName;
        this.form.goodsName = info.productName;
      }
      if (type === "3") {
      }
      if (type === "4") {
        this.form.content = info.serviceName;
        this.form.goodsName = info.serviceName;
      }
    },
    onSubmit() {
      let { form } = this;
      let _this = this;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          serviceOrderLogCommit(form).then((res) => {
            if (res.code === "-1") {
              _this.$message.warning(res.msg);
            } else {
              _this.$message.success("提交成功！");
              _this.$emit("input", false);
              _this.$refs.ruleForm.resetFields();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    cancel() {
      this.visible = false;
      this.$emit("input", false);
    },
  },
};
</script>

<style scoped lang="scss">
.service-form {
  width: 548px;
  > p {
    font-size: 20px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 600;
    text-align: center;
    line-height: 28px;
    padding-top: 24px;
    margin-bottom: 24px;
  }
  > form {
    background: #fff;
    padding: 24px 42px 24px 42px;
    ::v-deep {
      .ant-form-item-label {
        width: 100px;
      }
    }
  }
}
</style>

<style>
.consult-form-modal .ant-modal-body {
  padding: 0;
}
.consult-form-modal .ant-form-item {
  margin-bottom: 16px;
}
.consult-form-modal .ant-form-item:last-child {
  margin-bottom: 0;
}
</style>
